<template>
  <v-container>
    <div class="cards">
      <div class="header">
        <p class="font-weight-medium text-h6 text-md-h5 text-lg-h5 ml-3 my-3 pinkText">
          List Produk
        </p>
        <router-link
          class="text-right darkGreyText mt-2 mr-5 text-decoration-none font-weight-medium text-h6 text-md-h5 text-lg-h5"
          :to="`/products/nonreward`"
        >
          Lihat Semua
        </router-link>
      </div>
      <!-- ADD IF SLOW FETCH PRODUCT -->
      <div v-if="loadingProduct" class="d-flex flex-row flex-wrap containerCards">
        <div
          v-for="i in 12"
          :key="i"
          class="mb-2"
        >
          <CardLoading></CardLoading>
        </div>
      </div>
      <div v-else class="d-flex flex-row flex-wrap containerCards">
        <div
          v-for="product in this.products"
          :key="product.internalId"
          class="mb-2"
        >
            <router-link
              :to="`/product/${product.productCode}/nonreward/detail`"
              class="text-decoration-none"
            >
              <Card :product="product" :poin="false"></Card>
            </router-link>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Card from '@/components/Card/Card.vue'
import CardLoading from '@/components/Card/CardLoading.vue'

export default {
  components: { 
    Card,
    CardLoading },
  name: "ProductsDashboard",
  data() {
    return {
      products: [],
      selection: 1,
      pageSize: 12,
      loadingProduct: true,
    };
  },
  methods: {
    ...mapActions(["changeTitleApp", "getProducts"]),
    async loadProducts(){
      await this.getProducts({
        pageSize: this.pageSize,
        pageNumber: 1,
        productName: "",
        productPartnerRequestList: [],
        sort: ''
      })
      .then((response) => {
        console.log(response)
        this.loadingProduct = false;
        this.products = response.data.data.content;
        return this.$helpers.handleSuccess(response);
      })
      .catch((error) => {
        this.$helpers.handleError(error);
      });
    }
  },
  mounted() {
    //load produtcs
    this.loadProducts();
  },
  computed:{
    // loadingProduct(){
    //   return this.products.length;
    // }
  }
};
</script>

<style scoped src="./ProductsDashboard.scss" lang="scss" />
